import { useGQLMutation } from 'src/ui/utils/graphql';
import { CANCEL_APPOINTMENT } from 'src/graphql/Appointments';
import { useToast } from 'src/ui/components/Toast/ToastContainer';
import {
  Appointment,
  CancelAppointmentMutation,
  CancelAppointmentMutationVariables,
} from 'src/gql/graphql';
import { InitialContext } from 'src/pages/Layout/Layout';
import { useContext } from 'react';
import { Button } from '../../../../../../ui/components/Button/Button';
import { Modal, ModalBase } from '../../../../../../ui/components/Modal/Modal';
import { Heading } from '../../../../../../ui/components/Heading/Heading';
import styles from './CancelAppointmentModal.module.scss';

interface CancelAppointmentModalI extends ModalBase {
  appointment: Appointment;
}

export const CancelAppointmentModal = ({
  isOpen,
  setIsOpen,
  appointment,
}: CancelAppointmentModalI) => {
  const { setToast } = useToast();
  const { company } = useContext(InitialContext);
  const { mutation } = useGQLMutation<
    CancelAppointmentMutation['cancelAppointment'],
    CancelAppointmentMutationVariables
  >(CANCEL_APPOINTMENT, {
    onCompleted: (data) => {
      window.location.reload();
    },
    onError: (error) => {
      setToast({
        content: 'Error cancelling appointment. Please try again.',
        type: 'error',
      });
    },
  });

  const handleCancel = () => {
    mutation({
      variables: {
        appointmentId: appointment?.id, // Replace with the actual appointment ID
        companyId: company?.id,
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Heading className={styles.heading} headingLevel="h2">
        ¿Estás seguro de que deseas cancelar la cita?
      </Heading>
      <div className={styles.buttons}>
        <Button onClick={() => setIsOpen(false)}>Cerrar</Button>
        <Button
          className={styles['cancel-button']}
          btnStyle="secondary"
          onClick={handleCancel}
        >
          Confirmar cancelación
        </Button>
      </div>
    </Modal>
  );
};
